import apiClient from '../client'
import type { User } from '@/types'

export const authApi = {
  getConfig: () =>
    apiClient.get<{
      enabled: boolean
      client_id: string
      tenant_id: string
    }>('/api/auth/config'),

  getCurrentUser: () =>
    apiClient.get<User>('/api/users/me'),
}
